import { IClassroom } from "../../classrooms";
import { IUserResource } from "../../users";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalFilter, OneOrManyFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IDatavizLineResource, IDatavizLinesList } from "../types";

type DatavizActionType = IDatavizLineResource["id"];

export type IDatavizLineListQueryParameters = {
    filters?: {
        cumulatedNumber?: boolean;
        byLearner?: boolean;
        classroom: RelationalFilter<IClassroom>;
        learners: RelationalFilter<IUserResource>;
        action: OneOrManyFilter<DatavizActionType>;
        fromDate: string;
        toDate: string;
    };
};

export type IDatavizLineListQueryResult = IDatavizLinesList;

const mapFilters = (filters: IDatavizLineListQueryParameters["filters"]) => {
    const { classroom, action, fromDate, toDate, cumulatedNumber, byLearner, learners } = filters ?? {};
    return {
        "classroom.uuid": mapRelationalFilter(classroom),
        "learner.uuid": mapRelationalFilter(learners),
        "day[after]": fromDate,
        "day[before]": toDate,
        action,
        byLearner,
        cumulatedNumber,
    };
};

export const datavizLineListQuery: IApiQueryFunction<IDatavizLineListQueryParameters> = ({ filters }) => {
    return {
        method: "GET",
        url: `/dataviz_lines${serialize(mapFilters(filters), true)}`,
    };
};

export const useDatavizLineListQuery = createApiQueryHook<IDatavizLineListQueryParameters, IDatavizLineListQueryResult>(
    datavizLineListQuery,
);
